import { Stack, Text } from '@mantine/core'
import React, { useMemo } from 'react'
import { useAccount } from 'wagmi'

import { VotingActionProps } from '../NomineesList'
import VoteInput from '../VoteInput'

const VotingAction: React.FC<VotingActionProps> = ({
  isBreakpoint,
  votes,
  nominee,
  status,
  handleVoteChange,
  remainingVoteBalance,
  votingActive,
}) => {
  const { address } = useAccount()
  const totalVotes = useMemo(
    () => Object.values(votes).reduce((acc, curr) => acc + Number(curr.value), 0),
    [votes]
  )
  return (
    <Stack style={{ flexDirection: 'row', justifyContent: isBreakpoint ? 'center' : 'flex-end' }}>
      {status === 'REMOVED' ? (
        <Text>Candidate Removed by Foundation</Text>
      ) : (
        address &&
        votingActive && (
          <VoteInput
            remainingVoteBalance={remainingVoteBalance}
            isBreakpoint={isBreakpoint}
            totalVotes={totalVotes}
            votes={votes[nominee] || { value: '', touched: false, error: '' }}
            setVotes={value => handleVoteChange(nominee, value)}
          />
        )
      )}
      {!votingActive && <Text>Voting Phase has ended</Text>}
    </Stack>
  )
}

export default VotingAction
